export default __webpack_public_path__ + "static/media/upArrow.fe09f665.svg";